module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_XV"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvxv"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BBREVIATIONS")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("ACTP")])])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Ambrose."), _c('i', [_vm._v(" Commentary on Twelve Psalms")]), _vm._v(". Translated by Íde M. Ní Riain. Dublin: Halcyon Press, 2000.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ACW")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Ancient Christian Writers: The Works of the Fathers in Translation. Mahwah, N.J.: Paulist, 1946-.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("AF")])])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("J. B. Lightfoot and J. R. Harmer, trans."), _c('i', [_vm._v(" The Apostolic Fathers")]), _vm._v(". Edited by M. W. Holmes. 2nd ed. Grand Rapids, Mich.: Baker, 1989.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("AHSIS")])])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Dana Miller, ed."), _c('i', [_vm._v(" The Ascetical Homilies of Saint Isaac the Syrian.")]), _vm._v(" Boston, Mass.: Holy Transfiguration Monastery, 1984.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ANF")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("A. Roberts and J. Donaldson, eds. Ante-Nicene Fathers. 10 vols. Buffalo, N.Y.: Christian Literature, 1885-1896. Reprint, Grand Rapids, Mich.: Eerdmans, 1951-1956. Reprint, Peabody, Mass.: Hendrickson, 1994.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("AnSac")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("J. B. Pitra, ed. Analecta sacra et classica spicilegio solesmensi. Paris: Roger et Chernowitz; Rome: P. Cuggiani, 1888-1891. Reprint, Farnsborough, U.K.: Gregg Press, 1966.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("AOV")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Ambrose."), _c('i', [_vm._v(" On Virginity")]), _vm._v(". Translated by Daniel Callam, CSB. Toronto: Peregrina Publishing Co., 1996.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("ARL")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("St. Athanasius."), _c('i', [_vm._v(" The Resurrection Letters")]), _vm._v(". Paraphrased and introduced by Jack N. Sparks. Nashville: Thomas Nelson, 1979.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("CCL")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Corpus Christianorum Series Latina. Turnhout, Belgium: Brepols, 1953-.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("CCOP")])])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("John Chrysostom."), _c('i', [_vm._v(" Commentary on the Psalms")]), _vm._v(". Vol. 1. Translated by Robert Charles Hill. Brookline, Mass.: Holy Cross Orthodox Press, 1998.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("CS")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Cistercian Studies. Kalamazoo, Mich.: Cistercian, 1973-.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("CSCO")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Corpus Scriptorum Christianorum Orientalium. Louvain. Vienna, 1866-.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("FC")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Fathers of the Church: A New Translation. Washington, D.C.: Catholic University of America Press, 1947-.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("GAC")])])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Evagrius of Pontus: The Greek Ascetic Corpus.")]), _vm._v(" Translated by Robert E. Sinkewicz. Oxford Early Christian Studies. Oxford: Oxford University Press, 2003.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("GNTIP")])])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Ronald E. Heine, trans."), _c('i', [_vm._v(" Gregory of Nyssa’s Treatise on the Inscriptions of the Psalms")]), _vm._v(". Oxford Early Christian Studies. Oxford: Clarendon Press, 1995. ")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("JCC")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("John Cassian."), _c('i', [_vm._v(" Conferences")]), _vm._v(". Translated by Colm Luibheid. The Classics of Western Spiri"), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvxvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XVI"
    }
  }, [_vm._v("tuality. Mahwah, N.J.: Paulist, 1985.")])])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("LALM")])])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Anthony of Egypt."), _c('i', [_vm._v(" The Life of St. Anthony and the Letter to Marcellinus")]), _vm._v(". Translation and Introduction by Robert C. Gregg. The Classics of Western Spirituality. New York: Paulist Press, 1980.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("LCC")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("J. Baille et al., eds. The Library of Christian Classics. 26 vols. Philadelphia: Westminster Press, 1953-1966.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("MFC")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Message of the Fathers of the Church. Edited by Thomas Halton. Collegeville, Minn.: The Liturgical Press, 1983-.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("NPNF")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("P. Schaff et al., eds. A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church. 2 series (14 vols. Each). Buffalo, N.Y.: Christian Literature, 1887-1894. Reprint, Grand Rapids, Mich.: Eerdmans, 1952-1956. Reprint, Peabody, Mass.: Hendrickson, 1994.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("OCC")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Origen."), _c('i', [_vm._v(" Contra Celsum")]), _vm._v(". Translated with an Introduction and Notes by Henry Chadwick. Cambridge: Cambridge University Press, 1953.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("OIP")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Athanasius of Alexandria, “On the Interpretation of the Psalms.” In"), _c('i', [_vm._v(" Early Christian Spirituality,")]), _vm._v(" pp. 56-77. Translated by Pamela Bright. Sources of Early Christian Thought. Philadelphia: Fortress, 1986.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("OFP")])])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Origen."), _c('i', [_vm._v(" On First Principles")]), _vm._v(". Translated by G. W. Butterworth. London: SPCK, 1936; Reprint, Gloucester, Mass.: Peter Smith, 1973.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("OSW")])])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Origen: An Exhortation to Martyrdom, Prayer and Selected Writings")]), _vm._v(". Translated by Rowan A. Greer with Preface by Hans Urs von Balthasar. The Classics of Western Spirituality. New York: Paulist Press, 1979. ")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("PG")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("J.-P. Migne, ed. Patrologiae cursus completus. Series Graeca. 166 vols. Paris: Migne, 1857-1886.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("PL")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("J.-P. Migne, ed. Patrologiae cursus completus. Series Latina. 221 vols. Paris: Migne, 1844-1864.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("POG")])])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Eusebius."), _c('i', [_vm._v(" The Proof of the Gospel")]), _vm._v(". 2 vols. Translated by W. J. Ferrar. London: SPCK, 1920; Reprinted, Grand Rapids, Mich.: Baker, 1981.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("TTH ")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("G. Clark, M. Gibson and M. Whitby, eds. Translated Texts for Historians. Liverpool: Liverpool University Press, 1985-.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("WGRW")])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Writings from the Greco-Roman World. Atlanta: Society of Biblical Literature, 2001-.")])])]), _c('tr', [_c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("WSA")])])]), _c('td', [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("J. E. Rotelle, ed."), _c('i', [_vm._v(" Works of St. Augustine: A Translation for the Twenty-First Century.")]), _vm._v(" Hyde Park, NY: New City Press, 1995, 2000.")])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fb2ae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre5.vue
// module id = 75
// module chunks = 0